module.exports = __webpack_public_path__ + "img/Inactive-Managers@3x.9aa00cb6.png";